import { useRecoilState } from 'recoil'
import {
    newFormIdAtom,
    newFormServiceTypeAtom,
} from '../../../../../State/Atoms/FormProps/FormPropsAtoms'
import {
    assetServiceTypesAtom
} from '../../../../../State/Atoms/AssetData/AssetDataAtoms'
import { DropDownList } from '../../../../../../GlobalComponents/awc-reactjs-components'

export const AssetServiceTypeDropdown = () => {
    const [newFormId, setNewFormId] = useRecoilState(newFormIdAtom)
    const [newFormServiceType, setNewFormServiceType] = useRecoilState(newFormServiceTypeAtom)
    const [assetServiceTypes, ] = useRecoilState(assetServiceTypesAtom)

    const handleChooseServiceType = (event) => {
        setNewFormId(-1)

        setNewFormServiceType(event.target.value)
    }
    return (
        assetServiceTypes && (
            <div>
                <h3>Choose Service Type</h3>
                <div style={{ paddingTop: '20px', paddingBottom: '20px' }}>
                    <DropDownList
                        //name={props.name || ''}
                        key='ddlChooseAssetServiceType'
                        id='ddlChooseAssetServiceType'
                        className='form-control form-control-sm'
                        onChange={handleChooseServiceType}
                        options={[
                            {
                                ServiceTypeID: '',
                                ServiceDescription: '-- Select One --',
                            },
                            ...assetServiceTypes,
                        ].map((curAssetType) => (
                            <option
                                key={`serviceTypeOp${curAssetType.ServiceTypeID}`}
                                value={curAssetType.ServiceTypeID}
                            >{`${curAssetType.ServiceDescription.trim()}`}</option>
                        ))}
                    />
                </div>
            </div>
        )
    )
}
